<template>
  <Recall title="¿Ya tienes todo listo para empezar?" image="recall-woman">
    <Button tag="a" :href="route('funnel.new')">Simular una nueva hipoteca</Button>
    <Button btnStyle="secondary" tag="a" :href="route('funnel.improve')">Mejorar mi hipoteca actual</Button>
  </Recall>
</template>

<script>
import Recall from '@/lego/components/ctas/Recall.vue';
import Button from '@/lego/components/buttons/Button.vue';

export default {
  components: {
    Recall,
    Button,
  },
};
</script>
